import { createFileRoute } from '@tanstack/react-router'

import { preloadListPromotionGroups } from '@/api/react-query'
import { paginatedSearchWithSort } from '@/utils/route-utilities'

export const Route = createFileRoute('/_authenticated/_general/promotion-groups')({
	validateSearch: paginatedSearchWithSort(['name']),
	loaderDeps: ({ search: { limit, offset, q, sortBy, sortOrder } }) => ({
		limit,
		offset,
		q,
		sortBy,
		sortOrder
	}),
	loader: async ({ context, deps: { limit, offset, q, sortBy, sortOrder } }) =>
		await preloadListPromotionGroups(context, {
			query: {
				limit,
				offset,
				q,
				sortBy,
				sortOrder
			}
		}),
	staticData: {
		crumb: ({ context: { L } }) => L.Promotions.Groups()
	}
})
